// extracted by mini-css-extract-plugin
export default {"rightSide":"mentor_rightSide__f5OP1","bottomPart":"mentor_bottomPart__WQYUh","hide":"mentor_hide__4rvUl","show":"mentor_show__3UW1z","bars":"mentor_bars__iP9x9"};